import { DelayedReport, executeDelayedReport, getDelayedKey } from "../delayedReport/delayedReport";
import { ReportingEndpoint, ReportingUpType } from "../../services/reporting";
import { googleTagManager } from "../../utils/googleAnalytics";
import getUserSession from "../../utils/getUserSession";
export const PRODUCT_FROM_RECOMMENDATIONS = "product-seen-from-recommendations";
export const PRODUCT_CLICKED_FROM_RECOMMENDATIONS = "product-clicked-from-recommendations";
export function hasSvelteRecommendationsDelayedReport() {
    return getDelayedKey(PRODUCT_FROM_RECOMMENDATIONS) in localStorage || getDelayedKey(PRODUCT_CLICKED_FROM_RECOMMENDATIONS) in localStorage;
}
export const Recommendations = (getBase) => ({
    reportProductClicked: (props) => {
        if (props === null || props === void 0 ? void 0 : props.gtag_product_items) {
            googleTagManager('event', 'select_item', { items: props.gtag_product_items });
            delete props.gtag_product_items;
        }
        return DelayedReport(Object.assign(Object.assign({ prefix: PRODUCT_CLICKED_FROM_RECOMMENDATIONS, endpoint: ReportingEndpoint.General, upType: ReportingUpType.relatedProductClicked }, getBase()), { params: Object.assign({ reference: 'isp_rel_prd' }, props) }));
    },
    reportProductsShown: (props) => {
        if (props === null || props === void 0 ? void 0 : props.gtag_product_items) {
            googleTagManager('event', 'view_item_list', { items: props.gtag_product_items });
            delete props.gtag_product_items;
        }
        const userSession = getUserSession();
        let result = DelayedReport(Object.assign(Object.assign({ prefix: PRODUCT_FROM_RECOMMENDATIONS, endpoint: ReportingEndpoint.General, upType: ReportingUpType.relatedProductSeen }, getBase()), { params: Object.assign({ callback: 'ispRelatedDone', st: userSession !== null && userSession !== void 0 ? userSession : undefined }, props) }));
        setTimeout(() => { executeDelayedReport(PRODUCT_FROM_RECOMMENDATIONS); }, 200);
        return result;
    }
});
//# sourceMappingURL=recommendations.js.map